import { render, staticRenderFns } from "./icon-kakao.vue?vue&type=template&id=b662a450&scoped=true&"
import script from "./icon-kakao.vue?vue&type=script&lang=js&"
export * from "./icon-kakao.vue?vue&type=script&lang=js&"
import style0 from "./icon-kakao.vue?vue&type=style&index=0&id=b662a450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b662a450",
  null
  
)

export default component.exports